<template>
    <div class="llp-select">
        <vue-select :id="id" ref="select" v-model="componentModel" :class="[{'error': errors.length > 0}, classNames]"
                    :disabled="disabled" :get-option-label="label" :name="id" :options="options"
                    :reduce="reduce" :multiple="multiple"
                    :clearable="clearable"
                    @update:modelValue="newValue=> $emit('update:model', newValue)">
            <template v-slot:option="option">
                <span :title="label(option)" class="d-inline-block" data-bs-toggle="tooltip" tabindex="0">
                  <button class="btn bg-transparent p-0" type="button">{{ label(option) }}</button>
                </span>
            </template>
        </vue-select>
        <span v-if="errors.length === 1" class="text-danger">
            {{ errors[0].$message }}
        </span>
        <ul v-else-if="errors.length > 1" class="m-0">
            <li v-for="error in errors" :key="error.$uid" class="text-danger">
                <span class="text-danger">{{ error.$message }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  data: function() {
    return {
      // @NOTE this component model is needed on propose due to the needs by vue-select dependency
      // the props data model is read only
      // the props data model needs to be watched to manually update component model
      componentModel: this.model,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    reduce: {
      type: Function,
      required: false,
      default: option => option.id,
    },
    label: {
      type: Function,
      required: false,
      default: option => option.name,
    },
    model: {
      type: [Object, Number, String],
      required: false,
      default: null,
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    errors: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    disabled: {
      type: [Boolean, Function],
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  emits: ['update:model'],
  watch: {
    model: {
      handler: function(newValue) {
        this.componentModel = newValue;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    clear() {
      this.$refs.select.clearSelection();
    },
  },
};
</script>
